import React from "react";
import { DropdownButton } from "../Button";

import { connect } from "react-redux";
import paymentMode from "../../constants/paymentMode";
import { Checkbox } from "../Input";
import { onAddFilter } from "../../actions/Filters";

class PaymentMode extends React.Component {
  onCheck(el) {
    this.props.dispatch(
      onAddFilter({
        paymentMode: el,
      })
    );
  }
  render() {
    return (
      <DropdownButton
        leftIcon={this.props.icon}
        text={this.props.title}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.props?.filters?.paymentMode}
        clickOutside
      >
        {paymentMode.map((el, i) => {
          return (
            <Checkbox
              label={el.label}
              key={i}
              onCheck={() => this.onCheck(el)}
              checked={this.props?.filters?.paymentMode?.value === el.value}
            />
          );
        })}
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(PaymentMode);
